import React, { Component, FunctionComponent, ReactElement } from "react";

/** Utility functions (& type guards) to detect type of data passed (component or element, render function, etc.) */

export function isClassComponent(component: unknown): component is Component {
  return (
    typeof component === "function" && !!component.prototype.isReactComponent
  );
}

export function isFunctionComponent(
  component: unknown,
): component is FunctionComponent {
  return (
    typeof component === "function" &&
    String(component).includes("return React.createElement")
  );
}

export function isReactComponent(
  component: unknown,
): component is Component | FunctionComponent {
  return isClassComponent(component) || isFunctionComponent(component);
}

export function isReactElement(element: unknown): element is ReactElement {
  return React.isValidElement(element);
}

export function isDOMTypeElement(element: unknown): element is Element {
  return isReactElement(element) && typeof element.type === "string";
}

export function isCompositeTypeElement(
  element: unknown,
): element is ReactElement {
  return isReactElement(element) && typeof element.type === "function";
}
